import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import ParentDashboard from '../components/parent/ParentDashboard';
import './ParentDashboard.css';

const ParentDashboardPage = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.type !== 'parent') {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user || user.type !== 'parent') {
    return null;
  }

  return (
    <div className="parent-dashboard-page">
      <Routes>
        <Route path="/" element={<ParentDashboard />} />
        <Route path="*" element={<Navigate to="/parent" replace />} />
      </Routes>
    </div>
  );
};

export default ParentDashboardPage;

